<template>
  <div class="d-print text-dark">
    <div class="d-print__container no-print">
      <button slot="title"
              class="d-print__button"
              :class="{'do-bttn': activeCalendarDate}"
              @click="setIsDropdown"
              v-on-clickaway="setDropdownFromClick">
        <span class="icon-printer3"></span>
        <span class="icon-arrow-down5"></span>
      </button>
      <transition name="dropdown">
        <div class="d-print__container__dropdown" v-if="isDropdown">
          <ul>
            <li @click="printThis">{{ $t('vue2.print_all_calendars.this_calendar') }}</li>
            <li @click="selectType({type: 'multiple_calendars'})">
              {{ $t('vue2.print_all_calendars.custom') }}
            </li>
            <li v-for="type in calendarTypes" :key="type.type" @click="selectType(type)">
              {{ type.title }}
            </li>
          </ul>
        </div>
      </transition>
    </div>
    <div class="print-all text-dark">
      <d-modal v-if="isShowModal" :show-close="false">
        <div slot="insertComponent" class="print-all-modal">
          <div class="print-calendars__header border-1-bottom">
            <h3>{{ $t('vue2.print_all_calendars.only_printing_calendars_with_lessons') }}</h3>
            <div class="icon__bg-circle" @click="setIsShowModalFalse">
              <span class="icon-cross2"></span>
            </div>
          </div>
          <div class="print-all-modal__body">
            <div>
              <PrintCalendars
                :showDSelect="printCalendarType === 'multiple_calendars'"
                :calendarIds="calendarIds"
                :start-date="startDate"
                :end-date="endDate"
                :date="date"
                :firstDayOfWeek="firstDayOfWeek"
                @updateCalendars="updateSelectedCalendar($event)"
                @clear="clearSelectedCalendars">
              </PrintCalendars>
            </div>
          </div>
        </div>
      </d-modal>
      <div class="bg-overlay" v-if="isShowModal" @click="setIsShowModalFalse"></div>
    </div>
  </div>
</template>
<script>
import DModal from '../common/DModal'
import eventbus from '../../eventbus'
import PrintCalendarsWeekSelector from './PrintCalendarsWeekSelector'
import PrintCalendars from './PrintCalendars'
import moment from 'moment'
import DDropdown from '../common/DDropdown'
import {mixin as clickaway} from 'vue-clickaway'

export default {
  mixins: [clickaway],
  components: {DDropdown, PrintCalendars, PrintCalendarsWeekSelector, DModal},
  props: {
    calendarId: {
      default: 7
    },
    activeCalendarDate: {
      default: null
    }
  },
  data () {
    return {
      theStep: 1,
      calendarTypes: [
        {title: this.$t('vue2.print_all_calendars.all_classes'), type: 'klass'},
        {title: this.$t('vue2.print_all_calendars.all_teachers'), type: 'user'},
        {title: this.$t('vue2.print_all_calendars.all_rooms'), type: 'room'}
      ],
      date: moment().format('YYYY-MM-DD 00:00'),
      startDate: moment().isoWeek(1).startOf('day'),
      endDate: moment().isoWeek(7).endOf('day'),
      isDropdown: false,
      selectedCalendars: []
    }
  },
  computed: {
    firstDayOfWeek () {
      return this.$store.getters.firstDayOfWeek
    },
    allSchoolCalendars () {
      return this.$store.state.calendars
    },
    isShowModal () {
      return eventbus.isPrintCalendarsModal
    },
    printCalendarType () {
      return eventbus.printCalendarType
    },
    calendarIds () {
      let filteredCals = []
      if (this.printCalendarType === 'single_calendar') {
        filteredCals = this.allSchoolCalendars.filter(calendar => calendar.id === this.calendarId)
      } else if (this.printCalendarType === 'multiple_calendars') {
        filteredCals = this.selectedCalendars
      } else {
        filteredCals = this.allSchoolCalendars.filter(calendar => calendar.type === this.printCalendarType)
      }
      const sortedFilteredCals = filteredCals.sort((a, b) => {
        if (a.name && b.name) {
          return a.name.localeCompare(b.name, undefined, {
            numeric: true,
            sensitivity: 'base'
          })
        }
      })
      return this.printCalendarType ? sortedFilteredCals.filter(cal => cal.id).map(cal => cal.id) : []
    }
  },
  watch: {
    isShowModal (val) {
      if (!val) {
        this.resetForm()
      }
    }
  },
  methods: {
    clearSelectedCalendars () {
      this.selectedCalendars = []
    },
    updateSelectedCalendar (cals) {
      this.selectedCalendars = cals
    },
    getPrintingDate () {
      if (this.activeCalendarDate) {
        this.setDate(this.activeCalendarDate)
      } else {
        // For ROR
        const calendar = document.querySelectorAll('#calendar_' + this.calendarId)
        if (calendar.length > 0) {
          this.setDate(calendar[0].dataset.current_date)
        }
      }
    },
    setDropdownFromClick () {
      if (!this.isDropdown) {
        return
      }
      this.isDropdown = false
    },
    setIsDropdown () {
      if (!this.isDropdown) {
        this.getPrintingDate()
      }
      this.isDropdown = !this.isDropdown
    },
    setDate (date) {
      let selectedDate = moment(date).format('YYYY-MM-DD')
      if (this.firstDayOfWeek === 0) {
        // make sure it is the right week if week starts sunday
        selectedDate = moment(selectedDate).add(1, 'days')
      }
      this.date = selectedDate
      const endDayOfWeek = this.firstDayOfWeek + 6
      this.startDate = moment(selectedDate).isoWeekday(this.firstDayOfWeek).startOf('day')
      this.endDate = moment(selectedDate).isoWeekday(endDayOfWeek).endOf('day')
      this.theStep = 2
    },
    setIsShowModalFalse () {
      eventbus.isPrintCalendarsModal = false
      this.resetForm()
    },
    resetForm () {
      eventbus.printCalendarType = null
      this.theStep = 1
    },
    selectType (type) {
      this.isDropdown = false
      eventbus.printCalendarType = type.type
      this.theStep = 1
      eventbus.isPrintCalendarsModal = true
    },
    printThis () {
      this.isDropdown = false
      eventbus.printCalendarType = 'single_calendar'
      this.theStep = 1
      eventbus.isPrintCalendarsModal = true
    },
    printOld () {
      // functions from ROR the project
      window.noTextNoPrint()
      window.printCalendar(this.calendarId)
    }
  }
}
</script>

<style>
@import "../../assets/css/variables.css";

.print-all-modal {
  min-width: 550px;
  min-height: 450px;
}

.print-calendars__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
}

.print-calendars__header .close-cross {
  font-size: 1.2rem;
}

.print-all-modal__body h4 {
  padding: 1rem;
}

.select-calendar-type > ul > li {
  background: #ffffff;
  border: 1px solid var(--border-color);
  margin: 1rem;
  padding: 1rem;
  border-radius: 0.25rem;
  cursor: pointer;
  font-weight: bold;
  text-align: left !important;
}

.select-calendar-type > ul > li:hover {
  background: aliceblue;
}

.d-print__button {
  display: flex;
  align-items: center;
}

.d-print__button > .icon-arrow-down5 {
  margin-left: 5px;
}

.d-print__container {
  position: relative;
  display: inline-block;
}

.d-print__container__dropdown {
  position: absolute;
  z-index: 19990;
  top: calc(100% + 5px);
  right: 0;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .14);
  height: auto;
  outline: none;
  text-align: left;
  padding: 0.5rem;
  min-width: 150px;
}

.d-print__container__dropdown > ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.d-print__container__dropdown > ul > li {
  cursor: pointer;
  font-size: 13px;
  line-height: 18px;
  padding: 0.5rem;
  font-weight: normal;
  text-align: left !important;
}

.d-print__container__dropdown > ul > li:hover {
  background-color: #f5f6f7;
  border-radius: 4px;
}


</style>



// WEBPACK FOOTER //
// Print.vue?540a901a